import { TestbuyItemCard } from "@coworker/apprestructured/src/testbuy/components/TestbuyItemCard/TestbuyItemCard";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import React from "react";
import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import styles from "./testbuy-list-view-item.module.css";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import chevronRightIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronRightIconPath";

interface TestbuyItemListViewItemProps {
  item: Item;
  testbuyItem: TestBuyProductWithCriteria;
  badges?: ItemBadge[];
  navigationUrl: string;
}

export const TestbuyListViewItem = ({
  item,
  testbuyItem,
  badges,
  navigationUrl,
}: TestbuyItemListViewItemProps) => {
  return (
    <FixaLink
      to={navigationUrl}
      className={styles["list-item-root"] || ""}
      data-testid="testbuy-list-view-item"
    >
      <TestbuyItemCard
        badges={badges || []}
        testbuyItem={testbuyItem}
        item={item as Item}
        homeLocationGridCode={testbuyItem.location}
      />
      <div className={styles["list-item-right-arrow"] || ""}>
        <FixaSSRIcon paths={chevronRightIconPath} />
      </div>
    </FixaLink>
  );
};
